import React, { Component } from 'react';
// components
import ReactSwipe from 'react-swipe';
import Line from './components/Line';
import ModuleCircle from './components/ModuleCircle';
import ModuleDescription from '../../components/ModuleDescription/ModuleDescription';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Button from '../../components/Button/Button';
import RecoveryClock from '../RecoveryPlan/components/RecoveryClock';
// hoc
import { withRouter } from 'react-router-dom';
// shapes
import dashboard from '../../shapes/dashboard';
// styles
import styles from './Dashboard.mod.css';
import classnames from 'classnames/bind';
import Icon from '../../components/Icon/Icon';

let cx = classnames.bind(styles);

class MobileDashboard extends Component {
  constructor(props) {
    super(props);
    this.reactSwipe = React.createRef();
    const { currentModule, location } = props;
    const state = location.state || {};
    this.state = {
      currentSlide: state.id - 1 || currentModule,
    };
    // console.log('state_id', state.id - 1, 'currentModule', currentModule)
  }

  next = () => this.reactSwipe.current.next();
  prev = () => this.reactSwipe.current.prev();

  handleSwipe = () => {
    this.setState({
      currentSlide: this.reactSwipe.current.getPos(),
    });
  };

  handleClick = num => {
    const { history } = this.props;
    history.push(`/module/${num}`);
  };

  getActionButton = (index, state) => {
    const { role } = this.props;
    const isClient = role === 'client';

    if (!isClient) {
      return null;
    }
    switch (state) {
      case 'current':
        return (
          <Button
            onClick={() => this.handleClick(index)}
            className={cx('tablet-moduleButton-continue')}
            primary
          >
            Continue
          </Button>
        );
      case 'incomplete':
        return <Button className={cx('tablet-moduleButton')}>Locked</Button>;
      case 'complete':
        return (
          <Button
            link
            onClick={() => this.handleClick(index)}
            className={cx('tablet-moduleButton')}
          >
            Redo Module
          </Button>
        );
      default:
        return null;
    }
  };

  render() {
    const {
      getModuleState,
      currentProgress,
      currentModule,
      role,
      history,
      relapseAccess,
      dailyAccess,
      weeklyAccess,
      monthlyAccess,
      skillsAccess,
      modules,
    } = this.props;

    const { currentSlide } = this.state;

    const swipeOptions = {
      startSlide: Math.max(currentSlide, 0),
      continuous: false,
      callback: this.handleSwipe,
    };

    const isClient = role === 'client';

    return (
      <PageWrapper centered className={cx('dashboard')}>
        <RecoveryClock />
        <ReactSwipe
          direction="vertical"
          className="swiper-container"
          ref={this.reactSwipe}
          swipeOptions={swipeOptions}
        >
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(index => {
            const state = getModuleState(index);
            console.log(currentSlide, index);
            const isActive = currentSlide === index;
            return (
              <div key={index} className={cx('tablet-container')}>
                <div className={cx('tablet-circle-wrapper')}>
                  <Line
                    className={cx('line', { hide: index === 0 })}
                    solid={index < currentModule}
                  />
                  <ModuleCircle
                    tablet
                    name={index}
                    className={cx('tablet-module')}
                    state={state}
                    progress={currentProgress}
                  />
                  <Line
                    className={cx('line', { hide: index === 8 })}
                    solid={index < currentModule}
                  />
                </div>
                {isActive && (
                  <>
                    {this.getActionButton(index, state)}
                    <ModuleDescription
                      module={modules[index]}
                      className={cx('tablet-description-wrapper')}
                    />
                  </>
                )}
              </div>
            );
          })}
        </ReactSwipe>
        {isClient && (
          <div className={cx('tablet-extra-modules')}>
            <div className={cx('extra-module-wrapper')}>
              <ModuleCircle
                iconType="comment"
                name="Journal"
                onClick={() => {
                  history.push('/journal');
                }}
                className={cx('extra-module')}
                state="extra"
              />
            </div>
            {relapseAccess && (
              <div className={cx('extra-module-wrapper')}>
                <ModuleCircle
                  iconType="chevron-double-up"
                  name="Relapse"
                  onClick={() => {
                    history.push('/module/relapsemodule');
                  }}
                  className={cx('extra-module')}
                  state="extra"
                />
              </div>
            )}
            {skillsAccess && (
              <div className={cx('extra-module-wrapper')}>
                <ModuleCircle
                  onClick={() => {
                    history.push('/skills');
                  }}
                  iconType="calendar-alt"
                  name="Skills"
                  className={cx('extra-module')}
                  state="extra"
                />
              </div>
            )}
            {dailyAccess && (
              <div className={cx('extra-module-wrapper')}>
                <ModuleCircle
                  onClick={() => {
                    history.push('/daily-check-in');
                  }}
                  secondary
                  iconType="check-circle"
                  name="Daily check-in"
                  className={cx('extra-module', 'secondary')}
                  state="extra"
                />
              </div>
            )}
            {weeklyAccess && (
              <div className={cx('extra-module-wrapper')}>
                <ModuleCircle
                  onClick={() => {
                    history.push('/weekly-check-in');
                  }}
                  secondary
                  iconType="check-circle"
                  name="Weekly check-in"
                  className={cx('extra-module', 'secondary')}
                  state="extra"
                />
              </div>
            )}
            {monthlyAccess && (
              <div className={cx('extra-module-wrapper')}>
                <ModuleCircle
                  onClick={() => {
                    history.push('/monthly-check-in');
                  }}
                  secondary
                  name="Monthly check-in"
                  iconType="calendar-check"
                  className={cx('extra-module', 'secondary')}
                  state="extra"
                />
              </div>
            )}
          </div>
        )}
        <Icon
          type="chevron-up"
          onClick={this.next}
          className={cx('dashboard-nav', 'next', {
            hide: currentSlide === 7,
          })}
        />
        <Icon
          type="chevron-up"
          onClick={this.prev}
          className={cx('dashboard-nav', 'prev', {
            hide: !currentSlide || currentSlide === 0,
          })}
        />
      </PageWrapper>
    );
  }
}

MobileDashboard.propTypes = dashboard;

export default withRouter(MobileDashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/MobileDashboard.jsx